import { add } from './add';
import { create } from './create';
import { createApiKey } from './createApiKey';
import { deleteApiKey } from './deleteApiKey';
import { findAll } from './findAll';
import { findOne } from './findOne';
import { remove } from './remove';
import { search } from './search';
import { searchHosts } from './searchHosts';
import { update } from './update';

export const userAPI = {
  add,
  create,
  createApiKey,
  deleteApiKey,
  findAll,
  findOne,
  remove,
  search,
  searchHosts,
  update,
};
